import { ChangeDetectorRef, Component, Inject, Input, LOCALE_ID, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AddRequestInfoGQL } from 'app/shared/services/request-info/add-request-info.gql.service';
import { RequestInfoModel } from './request-info.model';
import { IUser } from '@collections/users/interfaces';
import { ICompany } from '@collections/companies/interfaces';
import { RequestStatusEnum, RequestTypeEnum } from '@collections/request-info/enums/request-info.enums';
import { INews } from '@collections/news/interfaces';
import { IProduct } from '@collections/products/interfaces';
import { UsersService } from 'app/shared/services/users/users.service';
import { NotificationService } from 'app/shared/services/notification/notification.service';
import { AddPortalRequestInfoGQL } from 'app/shared/services/request-info/add-portal-request-info.gql.service';
import { MatButton } from '@angular/material/button';
import { NgxMatIntlTelInputComponent } from 'ngx-mat-intl-tel-input';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { MatInput } from '@angular/material/input';
import { MatFormField, MatLabel, MatError } from '@angular/material/form-field';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';

@Component({
    selector: 'request-info',
    templateUrl: './request-info.component.html',
    styleUrls: ['./request-info.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [FormsModule, ReactiveFormsModule, MatRadioGroup, MatRadioButton, MatFormField, MatLabel, MatInput, CdkTextareaAutosize, MatError, NgxMatIntlTelInputComponent, MatButton],
    providers: [
        AddRequestInfoGQL,
        AddPortalRequestInfoGQL
    ]
})
export class RequestInfoComponent implements OnInit {

  requestSent: boolean = false; // Variabile per tenere traccia dello stato di invio della richiesta
  requestInfoForm: UntypedFormGroup;
  placeholder = '123-456-7890';
  @Input() mode: 'contacts' | 'stand' | 'news' | 'product';
  @Input() requestType: RequestTypeEnum = RequestTypeEnum.portalRequest;
  @Input() requestStatus: RequestStatusEnum = RequestStatusEnum.needValidation;
  @Input() company: ICompany;
  @Input() news: INews;
  @Input() product: IProduct;
  isLoggedIn = false;
  userInfo: IUser;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private addRequestInfoGQL: AddRequestInfoGQL,
    private addPortalRequestInfoGQL: AddPortalRequestInfoGQL,
    private cd: ChangeDetectorRef,
    @Inject(LOCALE_ID) public locale: string,
    private readonly usersService: UsersService,
    private notificationService: NotificationService

  ) { }

  ngOnInit(): void {

    this.requestInfoForm = this.formBuilder.group({
      text: ['', Validators.required],
      company: ['', Validators.required],
      phone: ['', Validators.required],
      reqType: [this.requestType || '', Validators.required]
    });

    if (this.mode == 'contacts') {
      this.requestInfoForm.addControl('mail', new UntypedFormControl('', [Validators.email]));
    }
  }

  ngOnDestroy(): void {
  }

  checkPermission() {
    if (this.mode === 'contacts') {
      this.sendMessage();
    } else {
      this.usersService.checkPermission(() => this.sendMessage());
    }
  }

  sendMessage(): void {
    if (this.mode == 'contacts' && !this.usersService.currentUserId) {
      if (this.requestInfoForm.valid) {
        const pem = this.populateModel(this.requestInfoForm.value);
        this.addPortalRequestInfoGQL.mutate({
          requestInfoInput: pem
        }).subscribe(this.onServerResponseObserver());
      }
    } else {
    if (this.requestInfoForm.valid) {
      const pem = this.populateModel(this.requestInfoForm.value);
      this.addRequestInfoGQL.mutate({
        requestInfoInput: pem
      }).subscribe(this.onServerResponseObserver());
    }
  }
  }

  populateModel(formValue: any): RequestInfoModel {
    const pm = new RequestInfoModel();
    pm.message = formValue.text;
    pm.company = formValue.company;
    pm.telephone = formValue.phone;
    pm.email = formValue.mail;
    pm.requestType = formValue.reqType;
    if (this.product && this.product.lang != this.locale) {
        pm.lang = this.product.lang;
    } else {
      pm.lang = this.locale;
    }
    if (this.company) {
      pm.recipientCompany = this.company._id;
    }
    pm.requestStatus = RequestStatusEnum.needValidation;
    if(this.news) {
      pm.recipientNews = this.news._id;
    }
    if(this.product){
      pm.recipientProduct = this.product._id;
    }

    return pm;
  }

  onServerResponseObserver(): any {
    return {
      error: err => {
        this.notificationService.showErrorMessage($localize`An error occurred. Please, try again later, or contact us.`);
      },
      complete: res => {
        this.notificationService.showSuccessMessage($localize`The request has been sent successfully.`, $localize`Save`);
        this.requestSent = true;
        this.cd.detectChanges();
      }
    };
  }
}
